<template>
  <div class="categories-grid-section">
    <div class="categories-grid-container">
      <div class="categories-grid">
        <a 
          v-for="category in displayCategories" 
          :key="category.id"
          :href="'/' + category.slug"
          class="category-grid-item"
        >
          <div class="category-grid-image">
            <img 
              v-if="category.image" 
              :src="category.image" 
              :alt="category.name"
              @error="$event.target.style.display='none'"
            />
            <div v-if="!category.image" class="category-grid-placeholder">
              <i :class="category.icon || 'fas fa-folder'"></i>
            </div>
          </div>
          <span class="category-grid-name">{{ category.name }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  categories: {
    type: Array,
    default: () => []
  },
  limit: {
    type: Number,
    default: 12
  }
})

const displayCategories = computed(() => {
  return (props.categories || []).slice(0, props.limit)
})
</script>
